import React from 'react';

function Donate(props) {
    return (
        <div className="Donate">
            <div className="container">
            <object type="text/html" data="https://foxdenedm.com/donate/" width="100%" height="100%"
                style={{
                display: 'flex',
                width: '84.7%',
                position: 'fixed',
                height: '87%'}}>
            </object>
            </div>
        </div>
    );
}

export default Donate;
